module.exports = __webpack_public_path__ + "img/WTA_PlayerZone_Mobile.853808f9.jpg";